module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-one",
    class: {
      'article-level-one--opinion': _vm.articleType === 'opinion'
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "d-flex align-self-top card-image"
  }, [(_vm.articleType === 'live') ? [(_vm.image) ? _c('SpeechBalloonLabel', {
    attrs: {
      "node": _vm.node,
      "size": "small",
      "mainComponent": "article-level-one",
      "shadow": ""
    }
  }) : _vm._e()] : _vm._e(), _c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": _vm.getGtmEvents.on,
      "gtm-event-action": _vm.getGtmEvents.action,
      "gtm-event-label": _vm.getGtmEvents.label
    }
  }, [(_vm.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.getArticleLazyloadImage(_vm.image, 1, 1, '5A9CB5', 20)),
      expression: "getArticleLazyloadImage(image, 1, 1, '5A9CB5', 20)"
    }],
    attrs: {
      "alt": _vm.node.title,
      "width": "106",
      "height": "106"
    }
  }) : _vm._e()])], 2), _c('div', {
    staticClass: "media-body"
  }, [_c('node-label', {
    staticClass: "card-section",
    attrs: {
      "node": _vm.node,
      "noColor": true
    }
  }, [(_vm.articleType === 'opinion') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "slot": "speechBalloonLabel",
      "node": _vm.node,
      "size": "small-20-responsive",
      "mainComponent": "article-level-one__node-label",
      "shadow": ""
    },
    slot: "speechBalloonLabel"
  })] : _vm._e()], 2), _c('div', {
    staticClass: "card-title"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": _vm.getGtmEvents.on,
      "gtm-event-action": _vm.getGtmEvents.action,
      "gtm-event-label": _vm.getGtmEvents.label
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1d3072a","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article-levels/Lv1.vue
// module id = 1050
// module chunks = 1 3 6 24